import {
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

interface Props {
  name: string;
  value: string;
  handleChange: any;
  disabled?: boolean;
  type?: string;
  placeholder: string;
  title: string;
  variant?: string;
  isRequiredFalse?: boolean;
  isTextArea?: boolean;
  maxChar?: number;
  rows?: number;
  resize?: "none" | "horizontal" | "vertical" | "both";
  sx?: Object;
}

const Index: React.FC<Props> = ({
  disabled,
  handleChange,
  name,
  value,
  type,
  placeholder,
  title,
  variant,
  isRequiredFalse,
  isTextArea,
  maxChar = 250,
  sx,
  rows,
  resize,
}) => {
  const textColor = useColorModeValue("navy.700", "white");
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const borderPrimary = useColorModeValue(
    "secondaryGray.100",
    "whiteAlpha.100"
  );

  return (
    <FormControl isRequired={!isRequiredFalse}>
      {title && (
        <FormLabel
          display="flex"
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          mb="8px"
        >
          {title}
        </FormLabel>
      )}

      {isTextArea ? (
        <Textarea
          fontSize="sm"
          fontWeight="500"
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          size="lg"
          maxLength={maxChar}
          border="1px solid"
          borderRadius="md"
          borderColor={borderPrimary}
          color={textColorPrimary}
          resize={resize ?? "none"}
          minH="auto"
          rows={rows ?? 1}
          sx={{
            whiteSpace: "pre-wrap",
            overflow: "hidden",
            padding: "12px",
            ...sx,
          }}
        />
      ) : (
        <Input
          variant={variant ?? "auth"}
          fontSize="sm"
          type={type ?? "text"}
          placeholder={placeholder}
          mb="24px"
          fontWeight="500"
          size="lg"
          value={value}
          name={name}
          onChange={handleChange}
          disabled={disabled}
          maxLength={maxChar}
          sx={sx}
        />
      )}
    </FormControl>
  );
};

export default Index;
